export class Passageiro {
    dataCriacao: string;
    dataUltimaAlteracao: string;
    ativo: boolean;
    nome: string;
    telefone: string;
    email: string;
    cpf: string;
    rg: string;
    rgDataEmissao: string;
    rgOrgaoExpedidor: string;
    dataNascimento: string;
    id: number;
    enderecoId: number;
    usuarioCriacaoId: number;
    usuarioUltimaAlteracaoId: number;
}

export class PassageiroDeslocamento {
    dataCriacao: string;
    dataUltimaAlteracao: string;
    ativo: boolean;
    deslocamentoId: number;
    passageiroId: number;
    pontoDeslocamentoEmbarqueId: number;
    pontoDeslocamentoDesembarqueId: number;
    acompanhante: boolean;
    id: number;
    usuarioCriacaoId: number;
    usuarioUltimaAlteracaoId: number;
}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/viagens/passageiros/shared/passageiro.model.ts
 **/